import { Publication } from 'model';
import { ManPage } from 'components/ManPage/ManPage';

export function Publications({ publications }: { publications: Publication[] }): JSX.Element {
  return (
    <ManPage
      name="texts"
      manual="Articles & Writing"
      sections={[
        { heading: 'NAME', body: 'texts - articles and writing' },
        {
          heading: 'ENTRIES',
          body: (
            <>
              {publications.map((p, i) => (
                <div key={i}>
                  <div>
                    <span className="man-sub">{p.date}</span>
                    {'  '}
                    <a href={p.url}>{p.title}</a>
                  </div>
                  <div>{p.description}</div>
                  {'\n'}
                </div>
              ))}
            </>
          )
        }
      ]}
    />
  );
}
